import React from 'react';

const closeSvg = () => (
    <svg width="24" height="18" viewBox="0 0 4 3" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.51458 0.602731L3.24727 0.335419L2.1875 1.39519L1.12773 0.335419L0.860413 0.602731L1.92018 1.6625L0.860413 2.72227L1.12773 2.98959L2.1875 1.92981L3.24727 2.98959L3.51458 2.72227L2.45481 1.6625L3.51458 0.602731Z" fill="#D80027"/>
    </svg>
)

export default closeSvg;